import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";
import { ContactServices } from "../api";

const onDefaultError = (error) => {
  toast.error(error.message);
};
/**
 * Hook for Admin Contact Master section
 */
const useListContact = ([page_no], onSuccess, onError = onDefaultError) => {
  return useQuery(["contact-list", page_no], ContactServices.contactList, {
    onSuccess,
    keepPreviousData: true,
    onError,
  });
};
const useUpdateContact = (onSuccess, onError = onDefaultError) => {
  return useMutation(ContactServices.updateContact, {
    onSuccess,
    onError,
  });
};
const useViewContact = (id, onSuccess, onError = onDefaultError) => {
  return useQuery("contact-view", () => ContactServices.viewContact({ id }), {
    onSuccess,
    onError,
  });
};
const useContactDelete = (onSuccess, onError = onDefaultError) => {
  return useMutation(ContactServices.deleteContact, {
    onSuccess,
    onError,
  });
};

export { useListContact, useUpdateContact, useViewContact, useContactDelete };
